<template>
  <div class="product-container">
    <div class="product" @click="gotoProduct(product.id)">
      <div class="img">
        <img :src="getProductImage(product)" :alt="product.name">
        <product-stock-display :product="product" />
      </div>
      <div class="row vcenter product-info">
        <div class="sm-7 meta">
          <span>{{ product.name }}</span>
          <span>$ {{ product.price }}</span>
        </div>
        <div class="sm-5 text-right">
          <!-- {{ productsToAdd.includes(product.id) }}
          {{ product.stock }} -->
          <button class="waves" :class="productsToAdd.includes(product.id) ? 'loading' : 'outline'" @click.stop="addToCart(product)">
            <span :style="`opacity: ${productsToAdd.includes(product.id) ? '0' : '1'}`">
              Buy
            </span>
          </button>
          <!-- <button v-else class="outline waves" @click="addToCart(product)">Buy</button> -->
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';

import { getProductPrimaryImage } from '@/utils';
import ProductStockDisplay from './ProductStockDisplay';

export default {
  name: 'ProductCard',
  components: {
    ProductStockDisplay,
  },
  props: {
    product: {
      type: Object,
      default: () => {}
    }
  },
  computed: {
    ...mapGetters({
      cart: 'Cart/cart',
    }),
  },
  data() {
    return {
      productsToAdd: []
    }
  },
  methods: {
    gotoProduct(id) {
      this.$router.push({ name: 'ProductDetails', params: { id } });
    },
    getProductImage(product) {
      return getProductPrimaryImage(product)
    },

    addToCart(product) {
      let foundItem = this.cart.find(
        (cartItem) => product.id === cartItem.product.id
      );

      if (foundItem) {
        if (foundItem.quantity >= product.stock) {
          // TODO: notify user that they have added all available productt 'x'
        } else {
          this.performAddToCart(product);
        }
      } else {
        this.performAddToCart(product);
      }
    },
    performAddToCart(product) {
      console.log('Product: ', product.id);

      if (!this.productsToAdd.includes(product.id))
        this.productsToAdd.push(product.id);

      this.$store.dispatch("Cart/addCartItem", product).then(() => {
        if (this.addCartItemStatus === 2) {
          // TODO: notify the user of success
          console.log(`${product.name} Added to cart successfully!`);
        } else if (this.addCartItemStatus === 3) {
          // TODO: notify the user of the error
          console.log("Could not add item to cart!", this.addCartItemMessage);
        }
        
        this.productsToAdd.splice(this.productsToAdd.indexOf(product.id), 1)
      });
    },
  }
}
</script>

<style lang="scss" scoped>
.product-container {
  width: 100%;

  // @media only screen and (min-width: 450px) {
  //   width: 50%;
  // }
  // @media only screen and (min-width: 700px) {
  //   width: calc(100% / 3);
  // }
  // @media only screen and (min-width: 992px) {
  //   width: 25%;
  // }

  .product {
    cursor: pointer;
    overflow: hidden;
    border-radius: 5px;
    background-color: white;

    .img {
      height: 200px;
      overflow: hidden;
      position: relative;

      img {
        transition: $transition-fast-out;
      }
    }

    .product-info {
      padding: .5rem .75rem;

      .meta {
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;

        span {
          display: block;
          opacity: .7;

          &:first-child {
            margin-bottom: .1rem;
            opacity: 1;
          }
        }
      }
      button {
        padding: .5rem .75rem;

        span {
          transition: inherit;
        }
      }
    }

    &:hover {
      img {
        transform: scale(1.025);
      }
    }
  }
}
</style>

<style lang="scss">
.theme-dark .product {
  background-color:  $dark-light-color !important;
}
</style>
